const CapsuleTableActions = () => {
    return <></>;
};

export default CapsuleTableActions;
